const SearchFiltersTabs = () => {
  const filterBtns = [...document.querySelectorAll(".search-result__filters-btn")];
  const tabs = [...document.querySelectorAll(".search-result__tab")];

  // if (filterBtns.length > 0 && tabs.length > 0) {
  //   filterBtns[0].classList.add("active");
  //   tabs[0].classList.add("active");
  // }

  filterBtns.forEach((filterBtn) => {
    filterBtn.addEventListener("click", () => {
      filterBtns.forEach((filterBtn) => {
        filterBtn.classList.remove("active");
      });

      filterBtn.classList.add("active");

      const activeCategory = filterBtn.getAttribute("data-category");

      tabs.forEach((tab) => {
        tab.classList.remove("active");
      });

      const activeTab = tabs.find((tab) =>
        tab.getAttribute("data-category") === activeCategory
      );

      if (activeTab) {
        activeTab.classList.add("active");
      }
    });
  });
}

export default SearchFiltersTabs;
